import * as actions from "../action.constants";

const initialState = {
  userModalStatus: false,
  userModalData: {},
  usersListDetails: {},
  profile: {},
  customerUserProfile: {},
  resources: {},
};

const addUserModalStatus = (state, action) => {
  return {
    ...state,
    userModalStatus: action.payload,
  };
};

const addUserModalData = (state, action) => {
  return {
    ...state,
    userModalData: action.payload || {},
  };
};
const saveGetUsersList = (state, action) => {
  return {
    ...state,
    usersListDetails: action.payload || {},
  };
};

const saveUserProfile = (state, action) => {
  return {
    ...state,
    profile: action.payload,
  };
};

const saveCustomerUserProfile = (state, action) => {
  return {
    ...state,
    customerUserProfile: action.payload,
  };
};

const saveOrgUsers = (state, action) => {
  return {
    ...state,
    orgUsers: action.payload,
  };
};

const saveUserResources = (state, action) => {
  return {
    ...state,
    resources: action.payload,
  };
};

const handlers = {
  [actions.SAVE_ADD_USER_MODAL_STATUS]: addUserModalStatus,
  [actions.SAVE_ADD_USER_MODAL_DATA]: addUserModalData,
  [actions.SAVE_GET_USERS_LIST]: saveGetUsersList,
  [actions.STORE_USER_PROFILE]: saveUserProfile,
  [actions.STORE_CUSTOMER_USER_PROFILE]: saveCustomerUserProfile,
  [actions.STORE_ORG_USERS]: saveOrgUsers,
  [actions.STORE_USER_RESOURCES]: saveUserResources,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
